/**
 * Regras do filtro salvo de relatorio (PHOENIX-107) que nao dependem de tela: o que vai para o back, o escopo, o
 * seletor de perfil e a pagina do painel.
 */

export const ESCOPO_USUARIO = 'usuario'
export const ESCOPO_PERFIL = 'perfil'

/** Escopo ao abrir o dialogo: Usuario (padrao do radio, como no ticket) ou o do filtro salvo na edicao. */
export const escopoInicial = (conjunto) => (conjunto && conjunto.oidPerfil ? ESCOPO_PERFIL : ESCOPO_USUARIO)

/**
 * O perfil do seletor: o do filtro salvo na edicao; num filtro novo, o unico perfil do usuario ja vem escolhido.
 *
 * @param perfis [{ id, value }] do back
 * @return { id, value } ou null
 */
export const perfilInicial = (conjunto, perfis) => {
  const lista = perfis || []
  if (conjunto && conjunto.oidPerfil) {
    const salvo = lista.find((perfil) => perfil.id === conjunto.oidPerfil)
    return salvo || { id: conjunto.oidPerfil, value: conjunto.nomePerfil || String(conjunto.oidPerfil) }
  }
  return lista.length === 1 ? lista[0] : null
}

/**
 * O corpo do POST/PUT de /conjuntos. Dono e empresa nao vao: vem do login. Escopo Usuario manda oidPerfil nulo.
 *
 * @param filtros o JSON ja montado (montarFiltros do dialogo)
 */
export const montarDtoConjunto = ({ conjunto, relatorio, descricao, padrao, escopo, perfil, filtros }) => ({
  oid: conjunto ? conjunto.oid : null,
  path: relatorio.path,
  oidDocumento: relatorio.oidDocumento || null,
  descricao,
  padrao: !!padrao,
  oidPerfil: escopo === ESCOPO_PERFIL && perfil ? perfil.id : null,
  filtros,
})

/** O que o preview do agendamento (/preview) recebe de um filtro salvo: relatorio e filtros, sem oid nem escopo. */
export const paraPreview = ({ path, oidDocumento, descricao, filtros }) => ({ path, oidDocumento, descricao, filtros })

/** Erro a mostrar antes de ir ao back: so o perfil, que o back recusaria com uma mensagem menos direta. */
export const faltaPerfil = (escopo, perfil) => escopo === ESCOPO_PERFIL && !perfil

/** "Visivel para" do painel: o nome do perfil, ou o texto de "so eu". */
export const visivelPara = (conjunto, textoSoEu) => (conjunto && conjunto.oidPerfil ? conjunto.nomePerfil : textoSoEu)

/** Perfis cujo nome ou codigo contem o texto (sem diferenciar maiusculas e acentos). */
export const filtrarPerfis = (perfis, texto) => {
  const busca = normalizar(texto)
  if (!busca) {
    return perfis || []
  }
  return (perfis || []).filter(
    (perfil) => normalizar(perfil.value).includes(busca) || String(perfil.id).includes(busca)
  )
}

/** Filtro das colunas do lookup de perfis: cada coluna so com o seu campo, as duas juntas quando preenchidas. */
export const filtrarPerfisPorColuna = (perfis, { nome, codigo }) => {
  const buscaNome = normalizar(nome)
  const buscaCodigo = normalizar(codigo)
  return (perfis || []).filter(
    (perfil) =>
      (!buscaNome || normalizar(perfil.value).includes(buscaNome)) &&
      (!buscaCodigo || String(perfil.id).includes(buscaCodigo))
  )
}

const normalizar = (texto) =>
  String(texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()

/** Pagina de uma lista carregada inteira (lookup de perfis). */
export const paginaLocal = (lista, first, rows) => (lista || []).slice(first, first + rows)

/**
 * O first a pedir de novo quando a pagina veio vazia (a lista encolheu, ex. excluido o unico item da ultima pagina):
 * o da ultima pagina que ainda tem itens, ou null quando a pagina vazia e a certa (nada salvo, ou ja na primeira).
 */
export const firstDaUltimaPagina = (first, rows, total) => {
  if (first <= 0 || total <= 0 || first < total) {
    return null
  }
  return Math.floor((total - 1) / rows) * rows
}

/** Troca {0}, {1}... pelos parametros, como o MessageFormat do back nos textos do dicionario. */
export const formatarTexto = (modelo, ...parametros) =>
  String(modelo || '').replace(/\{(\d+)\}/g, (marca, indice) =>
    parametros[indice] !== undefined && parametros[indice] !== null ? String(parametros[indice]) : marca
  )
